<ng-container *ngIf="control">
  <div
    [ngClass]="control.invalid && control.touched ? 'error mb-2' : 'mb-4'"
    class="form-input-wrapper">
    <ng-container *ngIf="inputData?.type === 'password'">
      <input
        class="form-input"
        [type]="hide ? 'password' : 'text'"
        [formControl]="control" />
      <label class="form-label" [for]="inputData.key">
        {{ inputData.label }} *
      </label>
      <span
        mat-icon-button
        matSuffix
        (click)="hide = !hide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide"
        [attr.aria-hidden]="true">
        <mat-icon>
          {{ hide ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="inputData?.type !== 'password'">
      <input
        class="form-input"
        [type]="inputData.type"
        [placeholder]="inputData.placeholder ?? ''"
        [formControl]="control" />
      <label class="form-label" [for]="inputData.key">
        {{ inputData.label }} *
      </label>
    </ng-container>
  </div>

  <!-- Validation Error -->
  <app-validation-error
    class="d-block mb-4"
    [control]="control"
    [inputData]="inputData"></app-validation-error>
</ng-container>
